export default function PrivacyPage() {
  return (
    <div className="bg-background min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-3xl font-bold text-text-primary mb-8">Privacy Policy</h1>
        <div className="prose prose-lg dark:prose-invert text-text-secondary max-w-none">
          <p>Last updated: January 2026</p>
          <p>
            At Rohith's Academy, we respect your privacy and are committed to protecting it. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website or use our application.
          </p>

          <h3>1. Information We Collect</h3>
          <p>We may collect personal information such as:</p>
          <ul>
            <li>Name and contact details (email, phone number).</li>
            <li>Account credentials (username, password).</li>
            <li>Payment information (processed securely by third-party providers).</li>
            <li>Usage data and course progress.</li>
          </ul>

          <h3>2. How We Use Your Information</h3>
          <p>We use the collected data to:</p>
          <ul>
            <li>Provide and manage our educational services.</li>
            <li>Process payments and subscriptions.</li>
            <li>Communicate with you regarding course updates and support.</li>
            <li>Improve our platform based on user feedback.</li>
          </ul>

          <h3>3. Data Security</h3>
          <p>
            We implement robust security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure.
          </p>

          <h3>4. Contact Us</h3>
          <p>
            If you have any questions about this Privacy Policy, please contact us at support@rohithsacademy.com.
          </p>
        </div>
      </div>
    </div>
  );
}

